<template lang="pug">
  .flow-builder-action-find-product
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform, platform_index) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform_index", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white
        p.mb-0 Nota en conversación
        p.text-secondary.text-sm Te permite enviar una nota personalizada en la conversación.
        fieldset.mb-3(:disabled="disabled")
          b-form-group(
            v-if="template_attribute.name === 'note_title'"
            v-for="template_attribute in Template_Attributes",
            :key="template_attribute.template_attribute_id",
            label="Título de nota:",
          )
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(
                placeholder="Variable",
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)"
              )
          b-form-group(
            v-if="template_attribute.name === 'description'"
            v-for="template_attribute in Template_Attributes",
            :key="template_attribute.template_attribute_id",
            label="Detalle de nota:",
          )
            vue-tribute(:options="tributeOpts")
              b-form-input.disabled-white(
                placeholder="Variable",
                :value="template_attribute.value",
                @blur="updateTemplateAttribute(template_attribute, $event)"
              )
</template>

<script>
import templateCommon from '@/helpers/template-common'
import TemplateTools from '@/components/templates/common/Tools.vue'
import _debounce from 'lodash.debounce'

export default {
  mixins: [templateCommon],
  data () {
    return {
    }
  },
  computed: {
  },
  components: { 'template-tools': TemplateTools },
  methods: {
    updateTemplateAttribute: _debounce(function(template_attribute, value) {
      const attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value.target._value

      this.updateAttribute(this.block_id, this.template_id, attribute).then(() => {
        this.$message.success('Actualizado')
      })
    }, 100, { leading: false, trailing: true })
  }
}
</script>

<style lang="scss" scoped>

  .flow-builder-action-find-product {
    position: relative;
    flex: 1 0 auto;
    max-width: 100%;
    background-color: transparent;
    white-space: normal;
  }
</style>
